// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2L8xH","rootCenter":"LoadMoreObserver_rootCenter__2jPes","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2hHme"};